import { PayloadAction } from "@reduxjs/toolkit";
import { takeLatest, put, call } from "redux-saga/effects";
import configueService from "./service";
import {
  forceUpdateRequest,
  forceUpdateSuccess,
} from "./slices/force-update-slice";
import {
  StudentCourseLookupRequest,
  StudentCourseLookupSuccess,
  emptyCourseData,
} from "./slices/student-course-slice";
import {
  emptyConfigData,
  featureConfigRequest,
  featureConfigSuccess,
} from "./slices/feature-config-slice";
import {
  StudentProgramLookupRequest,
  StudentProgramLookupSuccess,
  emptyProgramData,
} from "./slices/student-program-slice";
import {
  courseListRequest,
  courseListSuccess,
  emptyCourseListData,
} from "./slices/create-course-slice";
import {
  emptyProgramList,
  programListRequest,
  programListSuccess,
} from "./slices/create-program-slice";
import { emptyCreatePageLangPrefListData, emptyLanguageChoiceListData, emptyMainPageLangPrefListData, emptyUpdatePageLangPrefListData, getMainPageStatelanguagePrefListRequest, getMainPageStatelanguagePrefListSuccess, getStatelanguagePrefListRequest, getStatelanguagePrefListSuccess, getUpdatePageStatelanguagePrefListRequest, getUpdatePageStatelanguagePrefListSuccess, languageChoiceListRequest, languageChoiceListSuccess } from "./slices/language-preferance-slice";

function* getAppVersionsList(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getAppVersionListApi,action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(forceUpdateSuccess(res.data.data));
    }
  } catch (e) {
    console.log(e);
  }
}

function* getCourseLookup(action: PayloadAction<any>) {
  try {
    const res = yield call(
      configueService.getCourseLookupListApi,
      action?.payload
    );
    if (res.status === 200 && res.data.status === "success") {
      yield put(StudentCourseLookupSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyCourseData());
    }
  } catch (e) {
    console.log("error", e);
  }
}

function* getProgramLookup(action: PayloadAction<any>) {
  try {
    const res = yield call(
      configueService.getProgramLookupListApi,
      action?.payload
    );
    if (res.status === 200 && res.data.status === "success") {
      yield put(StudentProgramLookupSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyProgramData());
    }
  } catch (e) {}
}

function* getConfigList(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getConfigListApi, action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(featureConfigSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyConfigData());
    }
  } catch (e) {}
}

function* getCourseList(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getCourseListApi, action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(courseListSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyCourseListData());
    }
  } catch (e) {
    console.log("error", e);
  }
}

function* getProgramList(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getProgramListApi, action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(programListSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyProgramList());
    }
  } catch (e) {
    console.log("error", e);
  }
}

function* getStateLanguagePrefListCreate(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getStateLanguagePreferanceList, action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(getStatelanguagePrefListSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyCreatePageLangPrefListData());
    }
  } catch (e) {
    console.log("error", e);
    yield put(emptyCreatePageLangPrefListData());
  }
}
function* getStateLanguagePrefListUpdate(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getStateLanguagePreferanceListById, action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(getUpdatePageStatelanguagePrefListSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyUpdatePageLangPrefListData());
    }
  } catch (e) {
    console.log("error", e);
    yield put(emptyUpdatePageLangPrefListData());
  }
}

function* getMainPageStateLanguagePrefListCreate(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getStateLanguagePreferanceList, action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(getMainPageStatelanguagePrefListSuccess(res.data.data));
    } else if (res.data.status === "error") {
      yield put(emptyMainPageLangPrefListData());
    }
  } catch (e) {
    console.log("error", e);
    yield put(emptyMainPageLangPrefListData());
  }
}
function* getLanguageChoiceList(action: PayloadAction<any>) {
  try {
    const res = yield call(configueService.getLanguageChoice, action?.payload);
    if (res.status === 200 && res.data.status === "success") {
      yield put(languageChoiceListSuccess(res?.data?.data?.language_choices));
    } else if (res.data.status === "error") {
      yield put(emptyLanguageChoiceListData());
    }
  } catch (e) {
    console.log("error", e);
    yield put(emptyLanguageChoiceListData());
  }
}

export default function* configueSaga() {
  yield takeLatest(forceUpdateRequest.type, getAppVersionsList);
  yield takeLatest(StudentCourseLookupRequest.type, getCourseLookup);
  yield takeLatest(StudentProgramLookupRequest.type, getProgramLookup);
  yield takeLatest(featureConfigRequest.type, getConfigList);
  yield takeLatest(courseListRequest.type, getCourseList);
  yield takeLatest(programListRequest.type, getProgramList);
  yield takeLatest(getStatelanguagePrefListRequest.type, getStateLanguagePrefListCreate);
  yield takeLatest(getMainPageStatelanguagePrefListRequest.type, getMainPageStateLanguagePrefListCreate);
  yield takeLatest(languageChoiceListRequest.type, getLanguageChoiceList);
  yield takeLatest(getUpdatePageStatelanguagePrefListRequest.type, getStateLanguagePrefListUpdate);
}
